import type { Country } from '../dto/shared/SolarRequestDto'

const LANGUAGE_TO_COUNTRY: Record<string, Country> = {
  de: 'DE',
  es: 'ES',
  pl: 'PL',
}

/** German is shared by DE and AT, so region alone (not the base language) distinguishes them -
 *  checked against the full lowercased tag before falling back to the base-language lookup below. */
const REGION_TAG_TO_COUNTRY: Record<string, Country> = {
  'de-at': 'AT',
}

/** Maps the active UI language to a default Country for the request wizard's country dropdown -
 *  the language itself was already resolved from the Accept-Language header on first visit (see
 *  bootstrapLocale.ts), so this reuses that instead of a second header lookup. Falls back to DE
 *  for any language outside the supported ones. */
export function resolveDefaultCountry(language: string): Country {
  const full = language.toLowerCase()
  if (REGION_TAG_TO_COUNTRY[full]) {
    return REGION_TAG_TO_COUNTRY[full]
  }
  const base = full.split('-')[0]
  return LANGUAGE_TO_COUNTRY[base] ?? 'DE'
}

const POSTAL_CODE_PATTERNS: Record<Country, RegExp> = {
  DE: /^\d{5}$/,
  ES: /^\d{5}$/,
  PL: /^\d{2}-\d{3}$/,
  AT: /^\d{4}$/,
}

/** Non-blocking format check only - a mismatch is shown as a hint in the wizard, it never
 *  prevents publishing (bewusste Entscheidung, siehe tasks/plan zur Laenderunterstuetzung). */
export function postalCodeMatchesCountry(postalCode: string, country: Country): boolean {
  return POSTAL_CODE_PATTERNS[country].test(postalCode.trim())
}
